import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  IdDocumentsDetails = () =>{
  return(
   <DocumentDetails documentType={'id-documents'} keyAccess={'prebuilt-idDocument'} title={'ID Document'} exportDataToExcelName={'Id-Document'} analysefrom={'id-document'} deleteText={'id-document'} modelName={'doc-ai'} webSocketName={'iddocument'}/>
  )
 };
 export default IdDocumentsDetails;